

import { Component, Vue } from "vue-property-decorator";
import $ from "jquery";
import "@/common/scripts/ofi.min.js"
@Component({
  name: "qScripts",
  components: {},
})
export default class QScripts extends Vue {
  created(): void {
    this.muuqBase();
    // this.scroll();
  }

  muuqBase(): void {
    $(function () {
      //height 100vhがスマートフォンでアドレスバーを含めて取得してしまう問題回避
      // --vhというカスタムプロパティを作成
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
      // window resize
      window.addEventListener("resize", () => {
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
      });

      // slider
      $(window).on("load resize", function () {
        if ($(".js__slider-height").length > 0) {
          $(".js__slider-height .mb__slider-item > img").css(
            "height",
            $(
              ".js__slider-height .mb__slider-item_contants .mb__main-container"
            )
              .height()
              .toString(10) + "px"
          );
        }
      });

      //pagetop の実装
      var $footer = $("body > footer");
      var $pagetop = $(".js__pagetop");
      $pagetop.hide();

      //◇ボタンの表示設定
      $(window).scroll(function () {
        var scroll = $(this).scrollTop();
        var dHeight = $(document).height();
        var fHeight = $footer.height();
        var viewportHeight = $(window).height();
        var threshold = dHeight - viewportHeight - fHeight;
        if (scroll < 80) {
          //---- 画面を80pxスクロールしたら、ボタンを表示しない
          $pagetop.fadeOut();
          $pagetop.removeClass("js__pagetop-fixed");
        } else if (threshold < scroll) {
          $pagetop.addClass("js__pagetop-fixed");
        } else {
          //---- 画面が80pxより上なら、ボタンを表示する
          $pagetop.fadeIn();
          $pagetop.removeClass("js__pagetop-fixed");
        }
      });

      // toggle js
      $(document).on("click", ".js__togglebtn", function () {
        $(this).next().slideToggle();
        $(this).toggleClass("open");
      });

      // menu-list
      // $('.js__menu-listbtn').on("click", function(){
      //   $('.js__menu-list').slideToggle();
      //   $('.js__menu-list').toggleClass('open');
      // });

      // toggle js 2020 new
      $(".js__drill-key").click(function () {
        $(this).parent().next(".js__drill-box").slideToggle();
        $(this).toggleClass("open");
      });

      // 3点メニュー
      $(".js__menubtn").click(function () {
        $(this).next().toggleClass("open");
      });

      // 管理画面 メニューボタン実装
      $(".js_menu-btn").click(function () {
        $("body").toggleClass("open");
      });

      $(window).on('load resize', function() {
        $('.MainDetail').css('height', $('.mb__slider-item').height());
      });
    });
  }

  scroll(): void {
    /*--------------------------------------------------------------------------*
     *
     *  SmoothScroll JavaScript Library V2
     *
     *  MIT-style license.
     *
     *  2007-2011 Kazuma Nishihata
     *  http://www.to-r.net
     *
     *--------------------------------------------------------------------------*/

    new (function () {
      var attr = "data-tor-smoothScroll"; //for html5 , if you can't use html5 , this value change "class"
      var attrPatt = /noSmooth/;
      var d = document; //document short cut

      /*
	 *add Event
	  -------------------------------------------------*/
      function addEvent(elm, listener, fn) {
        try {
          // IE
          elm.addEventListener(listener, fn, false);
        } catch (e) {
          elm.attachEvent("on" + listener, function () {
            fn.apply(elm, arguments);
          });
        }
      }

      /*
	 *Start SmoothScroll
	  -------------------------------------------------*/
      function SmoothScroll(a) {
        if (d.getElementById(a.rel.replace(/.*\#/, ""))) {
          var e = d.getElementById(a.rel.replace(/.*\#/, ""));
        } else {
          return;
        }

        //Move point
        var end = e.offsetTop;
        var docHeight = d.documentElement.scrollHeight;
        var winHeight = window.innerHeight || d.documentElement.clientHeight;
        if (docHeight - winHeight < end) {
          var end = docHeight - winHeight;
        }

        //Current Point
        var start =
          window.pageYOffset ||
          d.documentElement.scrollTop ||
          d.body.scrollTop ||
          0;

        var flag = end < start ? "up" : "down";

        function scrollMe(start, end, flag) {
          setTimeout(function () {
            if (flag == "up" && start >= end) {
              start = start - (start - end) / 20 - 1;
              window.scrollTo(0, start);
              scrollMe(start, end, flag);
            } else if (flag == "down" && start <= end) {
              start = start + (end - start) / 20 + 1;
              window.scrollTo(0, start);
              scrollMe(start, end, flag);
            } else {
              scrollTo(0, end);
            }
            return;
          }, 10);
        }

        scrollMe(start, end, flag);
      }

      /*
	 *Add SmoothScroll
	  -------------------------------------------------*/
      addEvent(window, "load", function () {
        var anchors = d.getElementsByTagName("a");
        for (var i = 0, len = anchors.length; i < len; i++) {
          if (
            !attrPatt.test(anchors[i].getAttribute(attr)) &&
            anchors[i].href.replace(/\#[a-zA-Z0-9_]+/, "") ==
              location.href.replace(/\#[a-zA-Z0-9_]+/, "")
          ) {
            anchors[i].rel = anchors[i].href;
            anchors[i].href = "javascript:void(0)";
            anchors[i].onclick = function () {
              SmoothScroll(this);
            };
          }
        }
      });
    })();
  }
}
